module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-30-15-734.0632b710.mp4";